define("ember-svg-jar/inlined/document", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<path d=\"M3.714 15.428a1.35 1.35 0 01-1.01-.436 1.46 1.46 0 01-.419-1.05V2.058c0-.409.14-.758.42-1.05A1.35 1.35 0 013.714.572h5.714l4.286 4.457v8.915c0 .408-.14.758-.42 1.049-.28.291-.616.436-1.009.436H3.714zm5-9.657V2.057h-5v11.886h8.571V5.77H8.714z\" fill=\"currentColor\"/><path d=\"M4.857 7.428h6.285v1.143H4.857V7.428zm0 2h6.285v1.143H4.857V9.428zm0 2h4v1.143h-4v-1.143z\" fill=\"currentColor\"/>",
    "attrs": {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  };
});